<template>
    <div id="course-detail">
        <Head></Head>
        <div class="course-detail-head">
            <div class="head-container">
                <div class="head-profile">
                    <img :src="datas.resourceHeadImage">
                </div>
                <div class="head-info">
                    <div class="course-title">{{datas.resourceTitle}}</div>
                    <div class="course-scope">适用人群:{{datas.lessonForPeople}}</div>
                    <div class="course-section-info">
                        <span>{{datas.visitTimes}}人学过</span>
                        <span class="info-count">共{{datas.lessonCount}}课时</span>
                    </div>
                    <div class="course-rate">综合评分:5.0</div>
                </div>
            </div>
        </div>
        <div class="course-detail-main">
            <div class="main-head">
                <div class="main-head-menus">
                    <span :class="menu.id==selecId?selecClass:''" @click="selecMenu(menu.id)" v-for="menu in menus">{{menu.name}}</span>
                </div>
            </div>
            <div class="main-content">
                <div class="main-section container" v-show="selecId=='1'">
                    <ul v-for="chapter in chapterList" :key="chapter.videoChapterId">
                        <span>{{chapter.chapterTitle}}</span>
                        <li v-for="s in chapter.lstVideos" v-show="s.videoId!=''&&s.videoId!=undefined" @click="selecChapter(chapter.resourceId,s)">
                            <i class="icon iconfont icon-bofang1"></i>
                            <div class="chapter-name">{{s.videoName}}</div>
                            <div v-show="false" class="chapter-times">(播放{{s.watchCount}}次)</div>
                            <div class="chapter-score">
                                <div class="promotion-score">
                                    积分:<span>{{s.promotionScore}}</span>
                                </div>
                                <div class="original-score">
                                    (<span>{{s.originalScore}}</span>)
                                </div>
                            </div>
                            <div class="chapter-btn">开始学习</div>
                        </li>
                    </ul>
                </div>
                <div class="main-profile container" v-show="selecId=='2'">
                    <section class="main-profile-title">课程简介</section>
                    <span v-html="datas.resourceContent">{{datas.resourceContent}}</span>
                </div>
                <div class="main-material container" v-show="selecId=='3'">
                    <span v-html="datas.lessonAttach">{{datas.lessonAttach}}</span>
                    
                </div>
                <div class="main-rate container" v-show="selecId=='4'">
                    <div class="main-rate-title indent">综合评分</div>
                    <div class="rate-num indent">{{rateNum}}</div> 
                    <el-rate class="indent" v-model="rateNum"></el-rate>
                    <div class="rate-person indent">{{datas.ratePerson}}人评价</div>
                </div>
            </div>
        </div>
        <div class="course-detail-footer">

        </div>
        <!--页标签-->
        <div class="course-detail-tag">
            <div class="tag-info">
                <section>购买说明</section>
                <span>当前课程为付费资源，如需购买完整课程请点击下方按钮进行购买。课程所需积分【</span>
                <i class="icon iconfont icon-jifen" :title="'当前课程所需积分'+datas.score"></i>
                <span class="tag-score" :title="'当前课程所需积分'+datas.score">{{datas.score}}</span>
                <span>】。</span>
            </div>
            <div v-if="!isBuyAll" class="tag-btn" @click="bugLesson">
                <span>购买课程</span>
            </div>
        </div>
    </div>
</template>
<script>
import Head from '@/components/Head'

export default {
    data(){
        return{
            datas:{},
            chapterList:[],
            menus:[{
                id:'1',
                name:'课程章节'
            },{
                id:'2',
                name:'课程简介'
            },{
                id:'3',
                name:'学习资料'
            },{
                id:'4',
                name:'用户评价'
            }],
            selecClass:'span-select',
            selecId:'1',
            rateNum:5,
            resourceId:'',
            isBuyAll:false
        }
    },
    methods:{
        selecMenu(id){
            this.selecId=id;
        },
        selecChapter(id,data){
            this.$router.push({path:'lessonVideo',query:{resourceId:id,videoId:data.videoId}});
        },
        getQueryString(name) { 
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
            var r = window.location.search.substr(1).match(reg); 
            if (r != null) return unescape(r[2]); return null; 
        },
        bugLesson(){
            /**购买整套课程 */
            var that=this;
            var params =  this.$Qs.stringify({
                resourceId:this.resourceId
            });
            this.$Axios.post('/Wisdom/shop/hasShopChapter.htm',params).then((res)=>{
                var data=res.data;
                that.isBuyAll=false;
                if(data.code=='0'){
                    that.isBuyAll=true; 
                }else{
                     that.$confirm('是否购买全套课程？','提示',{
                        confirmButtonText: '购买',
                        cancelButtonText: '放弃',
                        type: 'warning'
                    }).then(()=>{
                        that.$Axios.post('/Wisdom/shop/shopVideo.htm',params).then((res)=>{
                            var data=res.data;
                            that.isBuyAll=false;
                            if(data.code=='0'){
                                that.$message.success("购买成功！");
                                that.isBuyAll=true;
                            }else if(data.code=='-1'){//未登录
                                this.$confirm(data.desc, '提示', {
                                    confirmButtonText: '前往登录',
                                    cancelButtonText: '暂不登录',
                                    type: 'warning'
                                }).then(()=>{
                                    that.axiosSendUrl(window.location.href,"/Wisdom/user/logo.htm");
                                });
                            }else if(data.code=='666666'){//积分不足
                                this.$confirm(data.desc, '提示', {
                                    confirmButtonText: '前往充值',
                                    cancelButtonText: '暂不充值',
                                    type: 'warning'
                                }).then(()=>{
                                    that.axiosSendUrl(window.location.href,"/Wisdom/jsp/pay2.jsp");
                                });
                            }
                        }).catch(function (error) {
                            that.isBuyAll=false;
                            that.$message.error(error);
                            
                        });
                    });
                }
            }).catch(function (error) {
                that.isBuyAll=false;
                that.$message.error(error);
            });

           

        },
        checkIsBuy(){
            var that=this;
            var params =  this.$Qs.stringify({
                resourceId:this.resourceId
            });
            this.$Axios.post('/Wisdom/shop/hasShopChapter.htm',params).then((res)=>{
                var data=res.data;
                that.isBuyAll=false;
                if(data.code=='0'){
                that.isBuyAll=true; 
                }
            }).catch(function (error) {
                that.isBuyAll=false;
                that.$message.error(error);
            }); 
        },
        axiosSendUrl(url,redirectUrl){
            var params =  this.$Qs.stringify({
                urlPageLocation:url
            });
            this.$Axios.post('/Wisdom/user/getPageLocation.htm',params).then((res)=>{
                window.location.href=redirectUrl;
            }).catch(function(error){
                window.location.href=redirectUrl;
            });
        } 

    },
    computed:{

    },
    mounted(){
        var id=this.$route.query.resourceId;
        this.resourceId=id;
        /**
         * 查询课程详情
         */
        var that=this;
        var params =  this.$Qs.stringify({
            resourceId:id
        });
        this.$Axios.post('/Wisdom/video/lessonDetail.htm',params).then((res)=>{
            var data=res.data;
            that.datas={};
            if(data.code=='0'){
                that.datas=data.data;
            }
        }).catch(function (error) {
　　         that.$message.error(error);
        });
        /**
         *查询章节信息
         */
        this.$Axios.post('/Wisdom/video/lessonChapterVideos.htm',params).then((res)=>{
            var data=res.data;
            that.chapterList=[];
            if(data.code=='0'){
                that.chapterList=data.data;
            }
        }).catch(function (error) {
　　         that.$message.error(error);
        });
        /**
         *查询是否购买全套
         */
        this.checkIsBuy();
    },
    components:{
        Head:Head
    }
}
</script>
<style scoped>
#course-detail{
    width: 100%;
    height: 100%;
}
.course-detail-head{
    width: 100%;
    height:200px;
    background-image:url("../../static/head.png");
    background-size: 100%;
}
.head-container{
    margin-left: calc(50% - 590px);
    width: 1160px;
    height: 100%;
}
.head-profile{
    float: left;
    margin-top: 40px;
}
.head-profile img{
    width: 180px;
    height: 120px;
}
.head-info{
    float: left;
    margin-left: 20px;
    color: white;
    margin-top: 30px;
}
.head-info div{
    margin-top: 7px;
}
.course-title{
    font-size: 25px;
    font-weight: bolder;
    font-family: 14px/1.5 "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
}
.course-detail-main{
    width: 100%;
    height: 100%;
}
.main-head{
    height: 80px;
    width: 100%;
    box-shadow: 5px 5px 10px #ccc;
    -moz-box-shadow: 5px 5px 10px #ccc;
    -webkit-box-shadow: 5px 5px 10px #ccc;
    -o-box-shadow: 5px 5px 10px #ccc;
    -ms-box-shadow: 5px 5px 10px #ccc;
}
.main-head-menus{
    margin-left: calc(50% - 590px);
    width: 1160px;
    height: 100%;
}
.main-head span{
    font-size: 18px;
    font-weight: bold;
    line-height: 80px;
    margin-right: 80px;
    cursor: pointer;
}
.main-head span:hover{
    color: red;
}
.span-select{
    color:red;
}
.course-detail-tag{
    position: absolute;
    top: 140px;
    right: calc(50% - 600px);
    width: 300px;
    height: 420px;
    box-shadow: 0px 8px 16px 0px #ccc;
    -moz-box-shadow: 0px 8px 16px 0px #ccc;
    -webkit-box-shadow: 0px 8px 16px 0px #ccc;
    -o-box-shadow: 0px 8px 16px 0px #ccc;
    -ms-box-shadow: 0px 8px 16px 0px #ccc;
    z-index: 20px;
    border-radius: 16px;
    -moz-border-radius: 16px;
    -webkit-border-radius: 16px;
    -o-border-radius: 16px;
    -ms-border-radius: 16px;
    background: #fff;
}
.tag-btn{
    position: absolute;
    left: 0;
    bottom: 50px;
    width: 100%;
    height: 50px;
}
.tag-btn span{
    display: block;
    width: 160px;
    height: 40px;
    line-height: 45px;
    margin-left: 70px;
    margin-top: 10px;
    text-align: center;
    background: #c20a0a;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    -o-border-radius: 3px;
    -ms-border-radius: 3px;
}
.tag-btn span:hover{
    background: rgba(194,10,10,0.4);
    cursor: pointer;
}
.tag-info{
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    color: rgba(0, 0, 0, 0.8);
}
.tag-info section{
    font-weight: bold;
    font-size: 15px;
    margin: 10px 0 10px 0;
}
.main-content{
    margin-top: 20px;
    margin-left: calc(50% - 590px);
    width: 1160px;
    height: auto;
}
.container{
    width: 880px;
    min-height: 300px;
    border: 1px solid rgba(204,204,204,0.3);
    box-shadow: 0px 8px 16px 0px #ccc;
}
.main-section ul{
    list-style: none;
    margin: 20px 0 10px 50px;
}
.main-section ul span{
    font-size: 16px;
    font-weight: bold;
}
.main-section ul li{
    margin: 0px 0 0px 20px;
    height: 50px;
    line-height: 50px;
}
.main-section ul li:hover{
    background: #ccc;
    color: #c20a0a;
    cursor: pointer;
}
.main-section ul li:hover .chapter-btn{
    width: 60px;
    height: 30px;
    float: right;
    background: #c20a0a;
    border-radius: 5px;
    margin-top: 10px;
    margin-right: 20px;
    font-size: 13px;
    line-height: 35px;
    color: #fff;
    padding-left: 10px;
}
.course-detail-footer{
    width: 1160px;
    height: 30px;
}
.icon-bofang1{
    font-size: 26px;
    line-height: 50px;
    float: left;
}
.chapter-name{
    font-size: 15px;
    font-weight:inherit;
    height: 50px;
    line-height: 50px;
    float: left;
    margin-left: 20px;
}
.chapter-times{
    font-size: 15px;
    margin-left: 30px;
    font-weight:inherit;
    float: left;
    height: 50px;
    line-height: 50px;
}
.chapter-btn{
    width: 60px;
    height: 30px;
    float: right;
    background: #fff;
    border-radius: 5px;
    margin-top: 10px;
    margin-right: 20px;
    font-size: 6px;
    line-height: 35px;
    color: #fff;
    padding-left: 10px;
}
.main-profile-title{
    margin: 20px 0 10px 50px;
    font-weight: bold;
    font-size: 15px;
}
.main-profile span{
    display: block;
    margin: 0 0 20px 50px;
}
.main-material span{
    display: block;
    margin: 20px 0 20px 50px;
}
.indent{
    margin: 20px 0 0px 50px;
}
.main-rate-title{
    font-size: 15px;
    font-weight: bold;
}
.rate-num{
    font-size: 60px;
    font-weight: 200;
    color: #ff9000;
}
.rate-person{
    font-size: 15px;
}
.chapter-score{
    font-size: 15px;
    margin-left: 30px;
    font-weight:inherit;
    float: left;
    height: 50px;
    line-height: 50px;
}
.original-score{
    float: left;
}
.original-score span{
   text-decoration:line-through;
   color: #ccc;
}
.promotion-score{
    float: left;
}
.promotion-score span{
    font-weight: bold;
    font-size: 16px;
    color: #c20a0a;
}
.main-section ul li:hover .original-score span{
    color: black;
}
.icon-jifen{
    font-size: 26px;
    color: #c20a0a;
}
.tag-score{
    font-size: 18px;
    color: #c20a0a;
    font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseDetail.vue